export default {
    m: 'Male',
    w: 'Female',
};
